import api from './api';

export const itemService = {
    getAllItems: (params) => api.get('/inventory/items', { params }),

    createItem: (itemData) => api.post('/inventory/items', itemData),

    updateItem: (id, itemData) => api.put(`/inventory/items/${id}`, itemData),

    deleteItem: (id) => api.delete(`/inventory/items/${id}`)
};
